<template>
  <div class="sdg-goals-display">
    <div class="sdg-icons-container">
      <v-tooltip 
        v-for="sdg in displayedGoals" 
        :key="sdg._id" 
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <div class="sdg-icon-wrapper">
            <v-img
              :src="sdg.icon"
              height="45px"
              width="45px"
              contain
              class="sdg-icon"
              v-bind="attrs"
              v-on="on"
            ></v-img>
          </div>
        </template>
        <span>{{ sdg.goalNumber }}. {{ sdg.title }}</span>
      </v-tooltip>
      
      <div v-if="showAddButton" class="add-btn-wrapper">
        <v-btn
          icon
          small
          color="primary"
          outlined
          @click="$emit('open-selector')"
          class="add-sdg-btn"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SdgGoalsDisplay',
  props: {
    selectedGoalIds: {
      type: Array,
      default: () => []
    },
    allSdgGoals: {
      type: Array,
      default: () => []
    },
    showAddButton: {
      type: Boolean,
      default: true  
    }
  },
  computed: {
    displayedGoals() {
      return this.allSdgGoals.filter(sdg => 
        this.selectedGoalIds.includes(sdg._id)
      );
    }
  }
};
</script>

<style scoped>
.sdg-goals-display {
  width: 100%;
  padding: 8px 0;
}

.sdg-icons-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.sdg-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
}

.sdg-icon {
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sdg-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.add-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 45px;
}

.add-sdg-btn {
  width: 40px;
  height: 40px;
}
</style>